import React from 'react'
import Contact from '../Contact'
import Footer from '../Footer'
import Header from '../Header'
import Newsletter from '../Newsletter'

const ContactPage = () => {
  return (
    <>

        <Header />
        <Contact />
        <Newsletter />
        <Footer />
      
    </>
  )
}

export default ContactPage
